import React, { Component } from 'react';
import PropTypes from 'prop-types';

class HiddenForm extends Component {
  constructor(props) {
    super(props);
    this.submitRef = React.createRef();
  }

  componentDidMount() {
    this.submitRef.submit();
  }

  render() {
    const { action, name, method, hidden_fields } = this.props.formData.form;
    return (
      <form
        className="fe-hide"
        ref={form => this.submitRef = form}
        action={ action }
        name={ name }
        method={ method }
      >
        {Object.keys(hidden_fields).map((key, idx) => (
          <input
            key={idx}
            type="hidden"
            name={key}
            value={hidden_fields[key]}
          />
        ))}
        <input
          type="hidden"
          name="_token"
          value={document.head.querySelector('meta[name="csrf-token"]').content}
        />
        <button type="submit">Submit</button>
      </form>
    );
  }
}

HiddenForm.propTypes = {
  formData: PropTypes.object.isRequired,
};

export default HiddenForm;